import { addDaysToDate, MILLISECONDS_TO_SECONDS } from "./Date";

export function isTokenWillExpireSoon(token: string, numDays: number) {
  const arrayToken = token.split(".");

  if (arrayToken.length > 1) {
    const tokenPayload = JSON.parse(atob(arrayToken[1]!));
    const nextExpirationDate = addDaysToDate(new Date(), numDays);

    return Math.floor(nextExpirationDate.getTime() / MILLISECONDS_TO_SECONDS) >= tokenPayload?.exp;
  }

  return true;
}
